import loadable from '@loadable/component'

import { Container } from '@uswitch/ev-core/react'
const Collection = loadable(() => import('../modules/collection'))

export const billboard = {
  variations: {
    default: loadable(() => import('../modules/billboard')),
  },
  wrapperConfig: { useContainer: false },
}

export const checklist = {
  variations: {
    default: loadable(() => import('../modules/checklist')),
  },
  wrapperConfig: { useContainer: false },
}

export const starRating = {
  variations: {
    default: loadable(() => import('../elements/star-rating')),
  },
}

export const readMore = {
  variations: {
    default: loadable(() => import('../elements/read-more-card')),
  },
}

export const prosAndCons = {
  variations: {
    default: loadable(() => import('../compounds/pros-and-cons')),
  },
}

export const accordion = {
  variations: {
    default: loadable(() => import('../compounds/accordion')),
  },
  hydrate: false,
}

export const articleIntro = {
  variations: {
    default: loadable(() => import('../compounds/article-intro')),
  },
  wrapperConfig: { useContainer: false },
  hydrate: true,
}

export const author = {
  variations: {
    default: loadable(() => import('../compounds/author')),
  },
  wrapperConfig: { useContainer: false },
}

export const profile = {
  variations: {
    default: loadable(() => import('../compounds/profile')),
  },
}

export const breadcrumb = {
  variations: {
    default: loadable(() => import('../compounds/breadcrumb')),
  },
  wrapperConfig: { spacingTop: 'sm' },
}

export const clickOutForm = {
  variations: {
    default: loadable(() => import('../compounds/click-out-form')),
  },
  hydrate: true,
}

export const categoryGuidesModule = {
  variations: {
    default: loadable(() => import('../modules/category-guides-module')),
  },
  wrapperConfig: { spacingTop: 'lg', spacingBottom: 'lg' },
  hydrate: { layout: 'carousel' },
}

export const contentHeroModule = {
  variations: {
    default: loadable(() => import('../modules/content-hero-module')),
  },
  wrapperConfig: { useContainer: false },
}

export const copyModule = {
  variations: {
    default: loadable(() => import('../compounds/copy')),
  },
}

export const cta = {
  variations: {
    default: loadable(() => import('../elements/cta')),
  },
  hydrate: true,
  wrapperConfig: { useContainer: false },
}

export const linkWithLabel = {
  variations: {
    default: loadable(() => import('../compounds/link-with-label')),
  },
}

export const embeddedAsset = {
  variations: {
    default: loadable(() => import('../elements/embedded-asset')),
  },
}

export const energySupplierModule = {
  variations: {
    default: loadable(() => import('../compounds/logobar')),
  },
  wrapperConfig: { useContainer: false },
}

export const energyHeroModule = {
  variations: {
    default: loadable(() => import('../compounds/hero')),
  },
  wrapperConfig: { useContainer: false },
}

export const energyAssuranceModule = {
  variations: {
    default: loadable(() => import('../modules/assurance-bar')),
  },
  wrapperConfig: { useContainer: false },
}

export const energyAssuranceListModule = {
  variations: {
    default: loadable(() => import('../compounds/assurance-text')),
  },
  wrapperConfig: { useContainer: false },
}

export const featuredCards = {
  variations: {
    default: loadable(() => import('../modules/featured-cards')),
  },
}
export const figureModule = {
  variations: {
    default: loadable(() => import('../modules/figure-module')),
  },
}

export const formInputText = {
  variations: {
    default: loadable(() => import('../compounds/form-input-text')),
  },
  hydrate: true,
}

export const formInputEmail = {
  variations: {
    default: loadable(() => import('../compounds/form-input-email')),
  },
  hydrate: true,
}

export const formInputSubmit = {
  variations: {
    default: loadable(() => import('../compounds/form-input-submit')),
  },
  hydrate: true,
}

export const gridColumnModule = {
  variations: {
    default: loadable(() => import('../compounds/grid/grid-column')),
  },
}

export const gridRowModule = {
  variations: {
    default: loadable(() => import('../compounds/grid/grid-row')),
  },
}

export const headingModule = {
  variations: {
    default: loadable(() => import('../compounds/heading')),
  },
}

export const providersLogoModule = {
  variations: {
    broadband: loadable(() => import('../modules/providers-logo-module')),
    default: loadable(() => import('../modules/providers-logo-module')),
  },
}

export const imageCalloutModule = {
  variations: {
    default: loadable(() => import('../modules/image-callout-module')),
  },
  wrapperConfig: { useContainer: false },
}

export const readMoreModule = {
  variations: {
    default: loadable(() => import('../modules/read-more-module')),
  },
  wrapperConfig: { useContainer: false },
}

export const iframeModule = {
  variations: {
    default: loadable(() => import('../compounds/iframe')),
  },
  wrapperConfig: { useContainer: false, spacingBottom: '1.5em' },
  hydrate: true,
}

export const collection = {
  variations: {
    default: Collection,
  },
  // Temporary until deprecated spacing options are removed
  wrapperConfig: { noWrapper: true },
  hydrate: { layout: ['carousel'] },
}

export const collectionModule = {
  variations: {
    default: Collection,
  },
  wrapperConfig: { noWrapper: true },
  hydrate: { layout: ['carousel'] },
}

export const listItem = {
  variations: {
    default: loadable(() => import('../elements/trustyle-list')),
  },
}

export const cardAwardNominee = {
  variations: {
    default: loadable(() => import('../compounds/card-award-nominee')),
  },
}

export const cardAwardWinner = {
  variations: {
    default: loadable(() => import('../compounds/card-award-winner')),
  },
}

export const reviews = {
  variations: {
    default: loadable(() => import('../modules/reviews')),
  },
  wrapperConfig: { useContainer: false },
}

export const testimonialCard = {
  variations: {
    default: loadable(() => import('../elements/testimonial-card')),
  },
}

export const video = {
  variations: {
    default: loadable(() => import('../compounds/video')),
  },
  hydrate: true,
}

export const list = {
  variations: {
    default: loadable(() => import('../elements/list')),
  },
}

export const imageModule = {
  variations: {
    default: loadable(() => import('../modules/image-module')),
  },
}

export const callOut = {
  variations: {
    default: loadable(() => import('../elements/call-out')),
  },
  wrapperConfig: { spacingTop: 'xs', spacingBottom: 'md' },
}

export const categoryHeadingModule = {
  variations: {
    default: loadable(() => import('../modules/category-heading-module')),
  },
  wrapperConfig: { useContainer: false },
}

export const table = {
  features: { localDates: true, globalDates: true },
  variations: {
    default: loadable(() => import('../compounds/table')),
  },
  hydrate: { sortable: [true] },
}

export const linkList = {
  variations: {
    default: loadable(() => import('../compounds/link-list')),
  },
  wrapperConfig: { useContainer: false },
}

export const embeddedVideo = {
  variations: {
    default: loadable(() => import('../elements/embedded-video')),
  },
  wrapperConfig: { useContainer: false },
  hydrate: true,
}

export const card = {
  variations: {
    default: loadable(() => import('../compounds/card')),
  },
}

export const cookieToggle = {
  variations: {
    default: loadable(() => import('../compounds/cookie-toggle')),
  },
  hydrate: true,
}

export const authorGuidesModule = {
  variations: {
    default: loadable(() => import('../modules/category-guides-module')),
  },
  wrapperConfig: { spacingTop: 'lg', spacingBottom: 'lg' },
}

export const authorProfile = {
  variations: {
    default: loadable(() => import('../modules/author-profile')),
  },
  wrapperConfig: { useContainer: false, spacingTop: 'xxl' },
}

export const button = {
  variations: {
    spark: loadable(() => import('../elements/button')),
    default: loadable(() => import('../elements/button')),
  },
  hydrate: true,
}

export const hero = {
  variations: {
    default: loadable(() => import('../modules/hero')),
  },
  wrapperConfig: { useContainer: false },
}

export const heroCard = {
  variations: {
    default: loadable(() => import('../compounds/hero-card')),
  },
}

export const iconTile = {
  variations: {
    default: loadable(() => import('../elements/icon-tile')),
  },
}

export const widgetHtml = {
  variations: {
    default: loadable(() => import('../elements/widget-html')),
  },
  hydrate: true,
}

export const productTable = {
  variations: {
    default: loadable(() => import('../modules/product-table')),
  },
  wrapperConfig: { useContainer: false },
}

export const form = {
  variations: {
    default: loadable(() => import('../modules/form')),
  },
  hydrate: true,
}

export const person = {
  variations: {
    default: loadable(() => import('../compounds/person')),
  },
}

export const sponsoredByTag = {
  variations: {
    default: loadable(() => import('../modules/sponsored-by')),
  },
  wrapperConfig: { useContainer: false },
}

export const countdown = {
  variations: {
    default: loadable(() => import('../compounds/countdown')),
  },
  hydrate: true,
}

export const leadCaptureForm = {
  variations: {
    default: loadable(() => import('../modules/lead-capture-form')),
  },
  hydrate: true,
}

export const navbar = {
  variations: {
    default: loadable(() => import('../modules/navbar')),
  },
}

export const vacancies = {
  variations: {
    default: loadable(() => import('../modules/vacancies')),
  },
}

export const supplierRow = {
  variations: {
    default: loadable(() => import('../compounds/supplier-row')),
  },
}

export const richTextModule = {
  variations: {
    default: loadable(() => import('../modules/rich-text')),
  },
  wrapperConfig: { useContainer: false },
}

export const experienceEntitySelector = {
  variations: {
    default: loadable(() =>
      import('@uswitch/ev-core/lib/components/modules/experience-entity-selector'),
    ),
  },
}

export const quoteBlock = {
  variations: {
    default: loadable(() => import('../compounds/quote-block')),
  },
  wrapperConfig: { useContainer: false },
}

export const subNavigationModule = {
  variations: {
    default: loadable(() => import('../modules/sub-navigation')),
  },
  wrapperConfig: { useContainer: false },
  hydrate: false,
}

export const container = {
  variations: {
    default: Container,
  },
}

export const palette = {
  variations: {
    default: loadable(() => import('../elements/palette')),
  },
}
